import { PublicClientApplication } from '@azure/msal-browser';
import { AUTH_CLIENTID, AUTH_TENANTID, AUTH_RETURN_URL, AUTH_MODE } from '@/config';

let msalInstance: PublicClientApplication | null = null;

export function getMsalInstance(): PublicClientApplication | null {
  return msalInstance;
}

export async function initializeMsal(): Promise<void> {
  if (AUTH_MODE !== 'azuread') return;

  msalInstance = new PublicClientApplication({
    auth: {
      clientId: AUTH_CLIENTID,
      authority: `https://login.microsoftonline.com/${AUTH_TENANTID}`,
      redirectUri: AUTH_RETURN_URL,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
  });

  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();
}
